import * as Constants from '../constants'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classes from "./ContatoPage.module.css";
import { faCircleInfo, faPaperPlane, faShare } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import Captcha from '../components/widget/Captcha';

function ContatoPage() {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [f, setF] = useState("");
  const [code, setCode] = useState("");

  const handleClick = async (event) => {
    event.preventDefault();
    // if (!captchaToken) {
    //   setStatus("Confirme o CAPTCHA.");
    //   return;
    // }

    // setIsLoading(true);

    // const token = localStorage.getItem("token");

    const form = event.currentTarget.closest('form');
    const nome = form.nome.value.trim();
    const email = form.email.value.trim();
    const telefone = form.telefone.value.trim();
    const mensagem = form.mensagem.value.trim();
    const f = form.f.value.trim();
    const code = form.code.value.trim();

    // Validação em JavaScript
    if (!nome) {
      alert('Por favor, preencha o seu nome.');
      form.nome.focus();
      return;
    }

    if (!email) {
      alert('Por favor, preencha o seu e-mail.');
      form.email.focus();
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Por favor, informe um e-mail válido.');
      form.email.focus();
      return;
    }

    if (!mensagem) {
      alert('Por favor, digite a sua mensagem.');
      form.mensagem.focus();
      return;
    }

    const dados = {
      nome,
      email,
      telefone: telefone || null,
      mensagem,
      f,
      code
      // captchaToken
    };

    // setIsLoading(true);

    try {
      const response = await fetch(Constants.CONTACT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dados),
      })
        .then(async response => {
          const responseJson = await response.json();

          console.log('HTTP:', response.status);
          console.log('Resposta:', responseJson);

          if (!response.ok) {
            throw new Error(
              responseJson.message || `Erro HTTP ${response.status}`
            );
          }

          return responseJson;
        })
        .then(responseJson => {
          if (responseJson.success) {
            console.log('Mensagem enviada:', responseJson.message);
            // setStatus("Mensagem enviada com sucesso!");
            setNome("");
            setEmail("");
            setTelefone("");
            setMensagem("");
            // setCaptchaToken(null);
          } else {
            console.warn('Backend retornou erro:', responseJson.message);
          }
        })
        .catch(error => {
          if (error.name === 'AbortError') {
            return;
          }

          console.error(
            'Erro na requisição:',
            error.message || error
          );
        })
        .finally(() => {
          // setIsLoading(false);
        });
    } catch (error) {
      // setStatus("Não foi possível enviar a mensagem.");
    }
  };

  return (
    <main>
      <section id="contato" className={classes.formulario}>
        <div className="interface">
          <h2 className="titulo">FALE<span> CONOSCO.</span></h2>

          <form>
            <input
              type="text"
              name="nome"
              id="nome"
              value={nome}
              placeholder="* Seu nome"
              onChange={(e) => setNome(e.target.value)}
            />
            <input
              type="text"
              name="email"
              id="email"
              value={email}
              placeholder="* Seu e-mail"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              name="telefone"
              id="telefone"
              value={telefone}
              placeholder="Seu celular"
              onChange={(e) => setTelefone(e.target.value)}
            />
            <textarea
              name="mensagem"
              id="mensagem"
              value={mensagem}
              placeholder="* Sua mensagem"
              onChange={(e) => setMensagem(e.target.value)}
            ></textarea>

            <Captcha
              url={"https://terradata.com.br/lib/captcha"}
            />

            <div className={classes.btnEnviar}>
              <div className={`btnContato ${classes.btnContato}`}>
                <button type="button" onClick={handleClick}>
                  <FontAwesomeIcon icon={faShare} />&nbsp;&nbsp;ENVIAR
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
      <br />
    </main>
  );
}

export default ContatoPage;